<template>
	<div 
	class="form-group" 
	:class="formGroupClass">
		
		<form-label 
		v-if="label" 
		:class="labelClass"
		:for="id"
		v-html="$sanitize(label)" />

		<div>
			[ Upload fichiers A faire ]
		</div>
		
		<form-errors v-if="errors" v-bind="{errors}" />
	    
	</div>
</template>

<script>

	import { mapState } from 'vuex'

	export default {

		props: {
			id: {
				type: String,
				default() {
					return `input-text-${this._uid}`
				},
			},

			formGroupClass: {
				type: [String, Array],
				default: ''
			},

			labelClass: {
				type: String,
				default: ''
			},

			type: {
				type: String,
				default: 'text',
			},

			errors: {
  				type: String,
 				default: "",
  			},

			border: {
				type: Boolean,
				default: true
			},

			value: [String, Number, Object, Array, Boolean],
			label: String,
		},

		computed: {

			val() {
				return this.value
			}

		},

		methods: {

			input(event) {
				this.$emit(
					'input', 
					event.target ? event.target.value : event
				)
			}
		},
	}

</script>